import React, { Component } from "react";
import Card from "components/Card/Card";
import Chart from "react-apexcharts";
import ExportButton from "components/Reports/ExportCSV";
import { Box } from "@chakra-ui/react";

class BarChart extends Component {
  constructor(props) {
    super(props);

    const transformedData = this.transformData(props.data);

    this.state = {
      chartData: [
        {
          name: props.title || "Data",
          data: transformedData.values,
        },
      ],
      chartOptions: {
        chart: {
          type: "bar",
          toolbar: { show: false },
        },
        xaxis: {
          title: {
            text: "Date",
            style: { color: "#fff", fontSize: '14px' }
          },
          categories: transformedData.labels,
          labels: { style: { colors: "#fff", fontSize: '10px' } },
        },
        yaxis: {
          title: {
            text: "Count",
            style: { color: "#fff", fontSize: '14px' }
          },
          labels: {
            style: { colors: "#fff", fontSize: "12px" },
            offsetX: 10, 
            maxWidth: 60,
          },
        },
        
        grid: { show: false },
        tooltip: { theme: "dark" },
        fill: { colors: ["#60A5FA"] },
      },
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data || prevProps.title !== this.props.title) {
      const transformedData = this.transformData(this.props.data);

      this.setState({
        chartData: [
          {
            name: this.props.title || "Data",
            data: transformedData.values,
          },
        ],
        chartOptions: {
          ...this.state.chartOptions,
          xaxis: {
            categories: transformedData.labels,
            labels: { style: { colors: "#fff" } },
          },
        },
      });
    }
  }

  transformData = (data) => {
    if (!data || data.length === 0) return { labels: [], values: [] };

    const slicedData = data.slice(-12); // Get last 12 entries

    const labels = slicedData.map((item) => {
      const date = new Date(item.date);
      return date.toLocaleDateString("en-US", { month: "short", day: "numeric" }); // e.g. "Apr 1"
    });

    const values = slicedData.map((item) => item.count);

    return {  labels, values };
  };


  formatChartDataForExport = () => {
    const { data } = this.props;
    return data?.map((item) => ({
      Date: item.date,
      Count: item.count,
    })) || [];
  };

  render() {
    const { showExportButton, fileName } = this.props;

    return (
      <Card
        py="1rem"
        height={{ base: "400px", md: "350px" }}
        width="100%"
        bg="linear-gradient(134.23deg, #071D54 14.41%, #1E3A8A 85.58%)"
        position="relative"
      >
        {showExportButton && (
          <Box position="absolute" top="10px" right="10px">
            <ExportButton
              data={this.formatChartDataForExport()}
              fileName={fileName || "chart_data"}
            />
          </Box>
        )}
        <Chart
          options={this.state.chartOptions}
          series={this.state.chartData}
          type="bar"
          width="100%"
          height="100%"
        />
      </Card>
    );
  }
}

export default BarChart;
